import { Role, TypeRole } from 'submodules/nail-supplier-base-model/models/Role';

export const checkPermissions = (roles: Role[], permittedRoles: TypeRole[]): boolean => {
    return roles.some((role) => permittedRoles.includes(role.Type));
};
